import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fonts/Roboto-Thin.ttf';
import './fonts/Roboto-Bold.ttf';
import './fonts/Roboto-Light.ttf';
import './fonts/Roboto-Black.ttf';
import './fonts/Roboto-Medium.ttf';
import './fonts/Roboto-Regular.ttf';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
